import { render, staticRenderFns } from "./ProductDetailPreview.vue?vue&type=template&id=647be8c3"
import script from "./ProductDetailPreview.vue?vue&type=script&lang=js"
export * from "./ProductDetailPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports